import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { DBRecurringExport } from '@/types/export';
import { EndpointResponse } from '@/types/endpoints';
import { utils } from '../../utils';
import type { ReadRequestOptions } from '../requestOptions';

const validate = (recurringExportId: number) => {
  if (!recurringExportId) {
    throw new Error('`recurringExportId` is required');
  }
};

type RequestParams = {
  recurringExportId: number;
};

type Response = DBRecurringExport;

export const getRecurringExportById = async (
  scope: RequestScope,
  { recurringExportId }: RequestParams,
  options: ReadRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    validate(recurringExportId);

    const result = await scopedApi(scope).get<EndpointResponse<Response>>(`/recurring_export/${recurringExportId}`, options);
    return result.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
